<!-- @format -->

@let productDetails = productDetailsData();
@let priceData = prices();
@let errors = productErrors();
@defer (when !isLoading()) {
	<div
		class="product-card-container hmf-display-flex hmf-flex-column gap-xs hmf-position-relative hmf-justify-content-between"
		[class]="isCompact() ? 'compact' : 'full-size'">
		<div
			class="hmf-display-flex hmf-flex-column"
			[class]="isCompact() ? 'gap-xxs' : 'gap-s'">
			<a
				class="hmf-display-flex hmf-flex-column no-underline"
				[class]="isCompact() ? 'gap-xxs' : 'gap-s'"
				tabindex="0"
				[attr.aria-label]="errors?.length ? `${compareBarProductData().name} can\'t be compared right now` : productNameAriaLabel()"
				[href]="redirectUrl()"
				(keydown.space)="goToProductDetailsPage($event)">
				<div class="product-image-wrapper">
					<div class="product-image">
						<hmf-product-image
							class="hmf-w-100"
							[ecode]="$safeNavigationMigration(productDetails?.style?.partNumber)"
							[imageData]="{
								imageUrl: compareBarProductData().gridImageURL
							}"></hmf-product-image>
					</div>
				</div>
				<span class="compare-product-name-section hmf-mb-0 truncate hmf-body-m hmf-display-block">{{ compareBarProductData().name }}</span>
			</a>
			@if (errors?.length) {
				<div>
					<hmf-alert-banner
						[type]="'alert'"
						[title]="'Can\'t compare this product right now.'">
					</hmf-alert-banner>
				</div>
			} @else {
				<div class="gap-xxs hmf-display-flex hmf-flex-column">
					<div class="price-section">
						@if (priceData) {
							<hmf-price
								class="hmf-pr-xxxs"
								[prices]="priceData"
								[isClearance]="priceIndicator() === 0"
								[isSeePriceInCart]="priceData.mapPriceIndicator === 1"></hmf-price>
						}
					</div>
					<div class="compare-rating-stars">
						@if (ratingCount() && ratingValue()) {
							<a
								class="hmf-display-block no-underline"
								[attr.aria-label]="reviewStarsAriaLabel()"
								[href]="redirectUrl()">
								<hmf-star-ratings
									[ratingCount]="ratingCount()"
									[ratingValue]="ratingValue()"
									[showRating]="false"
									[alignment]="'right'">
								</hmf-star-ratings>
							</a>
						}
					</div>
				</div>
			}
		</div>
		@if (errors?.length) {
			<button
				hmf-button
				class="select-options-button hmf-mb-xxs hmf-mb-sm-s"
				title="Remove from Product Comparison"
				[icon]="'delete-fill'"
				[size]="'small'"
				[label]="`${compareBarProductData().name} can\'t be compared at this time. Remove from Product Comparison`"
				[variant]="'destructive'"
				(click)="removeProductFromCompareGrid()">
				Remove
			</button>
		} @else {
			@if (compareBarProductData().compareSource === 'currentProduct') {
				<button
					hmf-button
					class="select-options-button hmf-mb-xxs hmf-mb-sm-s"
					title="Select Options"
					(click)="scrollToTop()"
					[label]="'Scroll to top of current product page to select options'"
					[size]="'small'"
					[variant]="'primary'">
					Select Options
				</button>
			} @else {
				<button
					hmf-button
					class="select-options-button hmf-mb-xxs hmf-mb-sm-s"
					title="Select Options"
					(click)="goToProductDetailsPage($event)"
					[label]="'Open product detail page to select options'"
					[size]="'small'"
					[variant]="'primary'">
					Select Options
				</button>
			}

			@if (badgeName()) {
				<hmf-badge
					class="badge hmf-position-absolute"
					[badgeName]="badgeName()"></hmf-badge>
			}

			@if (showRemoveButton()) {
				<button
					hmf-button
					class="product-remove-button hmf-position-absolute"
					title="Remove from Product Comparison"
					label="Remove from Product Comparison"
					[variant]="'secondary'"
					[size]="'medium'"
					[shape]="'circular'"
					[icon]="'delete-fill'"
					[iconSize]="'large'"
					(click)="removeProductFromCompareGrid()">
				</button>
			}
		}
	</div>
} @placeholder {
	<compare-components-skeleton-compare-grid-product-card
		class="hmf-w-100 hmf-display-flex hmf-align-self-stretch"
		[isCompact]="isCompact()">
	</compare-components-skeleton-compare-grid-product-card>
}
